/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ id: NonNullable<unknown> }} Developer_Client_Id_LabelInputs */



/**
* | output |
* | --- |
* | "Client ID: {id}" |
*
* @param {Developer_Client_Id_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_client_id_label = /** @type {((inputs: Developer_Client_Id_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Client_Id_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`ID client : ${i?.id}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`ID de cliente: ${i?.id}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Client ID: ${i?.id}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Client ID: ${i?.id}`)
	return /** @type {LocalizedString} */ (`Client ID: ${i?.id}`)
});